<template>
  <main>
    <menus/>
    <div class="cont">
      <nav>
        <span>订单状态：</span>
        <a :class="{ on: i === navIndex }" v-for="(v, i) in nav" :key="v.label" @click="changeNavIndex(i)">{{v.label}}</a>
      </nav>
      <el-table
        class="table"
        v-loading="loading"
        :data="list">
        <el-table-column prop="name" label="酒店名称"></el-table-column>
        <el-table-column prop="room_name" label="房型"></el-table-column>
        <!-- <el-table-column label="使用范围"></el-table-column> -->
        <el-table-column label="入住时间">
          <template slot-scope="s">
            <span>{{s.row.CheckInDate | format}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="下单时间">
          <template slot-scope="s">
            <span>{{s.row.created_at | format('MM-DD hh:mm')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="金额">
          <template slot-scope="s">
            <span class="price">{{s.row.total_amount}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="s">
            <span class="paid">{{s.row.status_text}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="s">
            <router-link :to="{name: 'hotel_order_pay', query: { orderNo: s.row.order_sn }}" class="pay_btn">支付</router-link>
            <router-link :to="{name: 'hotel_order_detail', query: { orders_sn: s.row.order_sn }}">详情</router-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="changePage"
        :hide-on-single-page="true"
        :total="total">
      </el-pagination>
    </div>
  </main>
</template>

<script>
import menus from '@components/menu';
import moment from 'moment';
import { mapState } from 'vuex';
export default {
  components: {
    menus
  },
  data () {
    return {
      navIndex: 0,
      loading: true,
      nav: [
        { label: '全部订单' },
        { label: '待支付' },
        { label: '已支付' },
        { label: '已完成' }
      ],
      search: {
        page: 1,
        rows: 10
      },
      total: 0,
      list: []
    }
  },
  async created () {
    this.getList();
  },
  filters: {
    format (val, desc = "MM月DD日") {
      return moment(val).format(desc);
    }
  },
  computed: {
    ...mapState([
      'userInfo'
    ])
  },
  methods: {
    changePage (page) {
      this.search = { ...this.search, page };
      this.getList();
    },
    getRequestData () {
      const {navIndex} = this;
      let data = { ...this.search };
      switch (navIndex) {
        case 1: {
          data.is_paid = 0;
          break;
        }
        case 2: {
          data.is_paid = 1;
          break;
        }
        case 3: {
          data.status = 23;
          break;
        }
      }
      return data;
    },
    async getList () {
      this.loading = true;
      const params = this.getRequestData();
      const { total, data } = await this.$axios.get(`hotelOrders/getOrdersByUser`, { params });
      this.list = data.map(v => ({...v, name: v.hotel_name ? v.hotel_name.split('(')[0] : '--'}));
      this.total = total;
      this.loading = false;
    },
    changeNavIndex (index) {
      if ( index === this.navIndex ) { return; }
      this.navIndex = index;
      this.search = { ...this.search, page: 1 };
      this.getList();
    }
  }
}
</script>

<style scoped src="./order.css"></style>